import FormHeader from "../FormHeader/FormHeader";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import PopUpModal from "../popupmodal/PopUpModal";
import React, { useEffect, useState } from "react";
import Images from "../../assets";

const AddSupplier = () => {

    const { control, handleSubmit, watch, setValue } = useForm({
        defaultValues: {
            bankDetails: [
                {
                    beneficiaryName: "",
                    beneficiaryAddress: "",
                    beneficiaryBankName: "",
                    accountNumber: "",
                },
            ],
        },
    });

    const {
        fields: bankFields,
        append: appendBanks,
        remove: removeBanks,
        replace: replaceBanks,
    } = useFieldArray({
        control,
        name: "bankDetails",
    });
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isPopupOpen, setPopupOpen] = useState(false);
    const togglePopup = () => {
        setPopupOpen(!isPopupOpen);
    };

    // POST API INTEGRATION START
    const { mutate, isSuccess, reset, isLoading } = useMutation(
        async (postData) => {
            try {
                console.error("postData :", postData);
                const response = await axios.post(
                    `${process.env.REACT_APP_HOST}/suppliers`,
                    postData
                );
                return response.data; // Return data if needed
            } catch (error) {
                console.error("Error in mutation function:", error);
                throw error; // Re-throw the error so that onError is triggered
            }
        },
        {
            onSuccess: () => {
                setPopupOpen(true);
                reset();
                console.log("Supplier added successfully.");
            },
            onError: (error) => {
                console.error("Mutation failed:", error);
            },
        }
    );
    // POST API END

    const UpdateAPI = useMutation(
        async (postdata) => {
            try {
                const response = await axios.put(
                    `${process.env.REACT_APP_HOST}/suppliers/${state && state?.supplierId
                    }`,
                    postdata
                );
                return response.data; // Return the response to the mutation
            } catch (error) {
                console.error("Error while updating data:", error);
                throw error; // Re-throw the error so that `onError` in useMutation is triggered
            }
        },
        {
            onSuccess: (val) => {
                console.log("Data updated successfully:", val);
                setPopupOpen(!isPopupOpen); // Close popup after success
            },
            onError: (error) => {
                console.error("Mutation failed:", error);
            },
        }
    );

    const onSubmit = (data) => {
        console.log("SK -> ", data);
        let formData = {
            supplierId: data?.supplierId,
            supplierName: data?.supplierName,
            mobileNo: data?.mobileNo,
            emailId: data?.emailId,
            foreignBankCharge: data?.foreignBankCharge,
            bankDetails: data?.bankDetails,
        };
        if (state && state?.customerId) {
            UpdateAPI.mutate(formData);
        } else {
            mutate(formData);
        }
    }

    useEffect(() => {
        setValue("supplierId", state?.supplierId);
        setValue("supplierName", state?.supplierName);
        setValue("mobileNo", state?.mobileNo);
        setValue("emailId", state?.emailId);
        setValue("foreignBankCharge", state?.foreignBankCharge);

        if (state?.bankDetails?.length > 0) {
            replaceBanks(
                state?.bankDetails?.map((item) => ({
                    beneficiaryName: item?.beneficiaryName || null,
                    beneficiaryAddress: item?.beneficiaryAddress || null,
                    beneficiaryBankName: item?.beneficiaryBankName || null,
                    accountNumber: item?.accountNumber || null
                }))
            );
        }
    }, [state, setValue]);

    return (<>
        <div className="add_customer_main_section p-0 m-0">
            <div className="add_customer_sub_block">
                <header>
                    <FormHeader header="ADD EXPORTER" />
                </header>
                <h6 className="packing-list-sub-heading  my-4">EXPORTER DETAILS</h6>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row g-3 add_user_input_block"> 
                        <div className="col-12 col-md-2">
                            <label className="add_customer_label">EXPORTER NAME :</label>
                        </div>
                        <div className="col-12 col-md-2">
                            <Controller
                                control={control}
                                name="supplierName"
                                render={({ field }) => (
                                    <input
                                        className="add_customer_input_field w-100"
                                        {...field}
                                        type="text"
                                        placeholder="Enter Exporter Name"
                                    />
                                )}
                            />
                        </div>

                        <div className="col-12 col-md-2">
                            <label className="add_customer_label">MOBILE NO :</label>
                        </div>
                        <div className="col-12 col-md-2">
                            <Controller
                                control={control}
                                name="mobileNo"
                                render={({ field }) => (
                                    <input
                                        className="add_customer_input_field w-100"
                                        {...field}
                                        type="tel"
                                        placeholder="9876543210"
                                    />
                                )}
                            />
                        </div>

                        <div className="col-12 col-md-2">
                            <label className="add_customer_label">EMAIL ID:</label>
                        </div>
                        <div className="col-12 col-md-2">
                            <Controller
                                control={control}
                                name="emailId"
                                render={({ field }) => (
                                    <input
                                        className="add_customer_input_field w-100"
                                        {...field}
                                        type="email"
                                        placeholder="example@gmail.com"
                                    />
                                )}
                            />
                        </div>

                        <div className="col-12 col-md-2">
                            <label className="add_customer_label">FOREIGN BANK CHARGE :</label>
                        </div>
                        <div className="col-12 col-md-2">
                            <Controller
                                control={control}
                                name="foreignBankCharge"
                                render={({ field }) => (
                                    <select
                                        {...field}
                                        className="add_customer_input_field w-100"
                                    >
                                        <option value="-1">Select</option>
                                        <option value="OUR">OUR</option>
                                        <option value="SHA">SHA</option>
                                    </select>
                                )}
                            />
                        </div>
                    </div>

                    <h6 className="packing-list-sub-heading  my-4 mx-0">BANK DETAILS</h6>

                    {bankFields?.map((field, index) => {
                        return (
                            <div key={field?.id}>
                                <h6 className="packing-list-sub-heading  my-4 mx-0">
                                    BANK {index + 1}
                                </h6>
                                {index > 0 && (
                                    <>
                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "end",
                                                padding: "10px 20px",
                                            }}
                                        >
                                            <img
                                                src={Images?.deleteIcon}
                                                alt="no-image"
                                                style={{
                                                    width: "25px",
                                                    height: "25px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    removeBanks(index);
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                                <div className="row g-3 add_user_input_block">
                                    <div className="col-12 col-md-2">
                                        <label className="add_customer_label">BENEFICIARY NAME :</label>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <Controller
                                            control={control}
                                            name={`bankDetails.${index}.beneficiaryName`}
                                            render={({ field }) => (
                                                <input
                                                    className="add_customer_input_field w-100"
                                                    {...field}
                                                    type="text"
                                                    placeholder="Enter Name"
                                                />
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2">
                                        <label className="add_customer_label">BENEFICIARY ADDRESS :</label>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <Controller
                                            control={control}
                                            name={`bankDetails.${index}.beneficiaryAddress`}
                                            render={({ field }) => (
                                                <input
                                                    className="add_customer_input_field w-100"
                                                    {...field}
                                                    type="text"
                                                    placeholder="Enter Address"
                                                />
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2">
                                        <label className="add_customer_label">BENEFICIARY BANK NAME, ADDRESS AND SWIFT CODE :</label>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <Controller
                                            control={control}
                                            name={`bankDetails.${index}.beneficiaryBankName`}
                                            render={({ field }) => (
                                                <input
                                                    className="add_customer_input_field w-100"
                                                    {...field}
                                                    type="text"
                                                    placeholder="Enter Name, Address, Swift Code"
                                                />
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2">
                                        <label className="add_customer_label">ACCOUNT NUMBER :</label>
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <Controller
                                            control={control}
                                            name={`bankDetails.${index}.accountNumber`}
                                            render={({ field }) => (
                                                <input
                                                    className="add_customer_input_field w-100"
                                                    {...field}
                                                    type="number"
                                                    placeholder="Enter A/C No"
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div
                        className="row  add_user_input_block my-5"
                        onClick={() => {
                            appendBanks({
                                beneficiaryName: "",
                                beneficiaryAddress: "",
                                beneficiaryBankName: "",
                                accountNumber: "",
                            });
                        }}
                    >
                        <div className="col-12 shippingAdressAppendBlock">
                            <div className="shippingAdressInnerBlock">
                                <h5 className="shippingAddressAppendHeading">ADD BANK</h5>
                            </div>
                        </div>
                    </div>
                    <div className="row my-5">
                        <div className="col-12 d-flex justify-content-center">
                            <button className="add_customer_submit_btn">
                                {isLoading ? (
                                    <i class="fa fa-spinner fa-spin"></i>
                                ) : (
                                    <>SUBMIT</>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
            <div className="img-block">
                <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
                    <img
                        src={Images?.logo}
                        style={{ width: "100%", height: "100%" }}
                        alt="No-Image"
                    />
                </div>
            </div>
            <div className="d-flex flex-column align-items-center justify-content-center py-2">
                {state && state?.supplierId ? (
                    <>
                        <h6 className="popup-content mb-3">
                            Exporter Has Been Updated Successfuly
                        </h6>
                    </>
                ) : (
                    <>
                        <h6 className="popup-content mb-3">
                            Exporter Has Been Added Successfuly
                        </h6>
                    </>
                )}

                <button
                    className="user-add-button mt-2 mb-2"
                    onClick={() => {
                        navigate("/viewSupplier");
                    }}
                >
                    OK
                </button>
            </div>
        </PopUpModal>
    </>)
};

export default AddSupplier;